import styles from './invictustest.module.css'
import { getExamType } from 'utils/common'
import { useScrollControl } from "ScrollControlContext";

const InvictusEliteProgram = () => {
    const { skipScrollEffect } = useScrollControl();

    const scrollToSection = (id) => {
        console.log("test");
        const el = document.getElementById(id);
        if (!el) return;

        // Disable scroll effect before scrolling
        skipScrollEffect.current = true;
        el.scrollIntoView({ behavior: "smooth", block: "start" });

        // Re-enable it after 700ms (adjust as needed)
        setTimeout(() => {
            skipScrollEffect.current = false;
        }, 700);
    };
    const examType = getExamType();
    function applyprocess() {
        window.webengage.track(examType + '_apply_for_selection', {
            exam_type: examType,
            page_url: window.location.href,
            "utm parameters": localStorage.getItem("utmParams") ? localStorage.getItem("utmParams") : ""
        })
    }

    return (
        <div style={{ background: "#fff" }}>
            {/* jee advanced elite start */}
            <div className="container p-lg-2 pe-3 ps-3">
                <div className={`${styles.jee_advanced_elite}`}>
                    <div className={`${styles.jee_elite_content}`}>
                        <h4>JEE Advanced Elite Program</h4>
                        <p>
                            Only for the Most Dedicated for IITs
                        </p>
                        <div className={`${styles.grey_box_jee}`}>
                            <p>Not Just Another Course – A Challenge!<br />Limited Seats – Only the Best Get In!</p>
                        </div>
                    </div>
                    <div className={`${styles.admiss_info}`}>
                        <p>🚨 Admissions Closing Soon!</p>
                        <div className={`${styles.selection_box}`}> <a href="#isregister" onClick={() => {
                            scrollToSection("register_now");
                            applyprocess();
                        }} className={`${styles.apply_process_btn}`}>Apply Now</a> </div>
                    </div >
                </div >
            </div >
            {/* jee advanced elite end */}
        </div >
    )
}

export default InvictusEliteProgram